import { render, staticRenderFns } from "./RegisterAfter.vue?vue&type=template&id=185cf0bf&scoped=true"
import script from "./RegisterAfter.vue?vue&type=script&lang=js"
export * from "./RegisterAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185cf0bf",
  null
  
)

export default component.exports